import React from 'react'

const SubSectionTitle = ({children}) => {
  return (
    <h4 className="estilo text-3xl mt-10 text-center font-bold mr-4">{children}</h4>
  )
}

export default SubSectionTitle